import React from 'react';
import { createUseStyles } from 'react-jss';
import { Dropdown } from 'primereact/dropdown';



function MzDropdown({ options, optionLabel,placeholder,  stateValue, setStateValue, onChange }) {
    const st = styles();
  
    let [borderStyle, setBorderStyle] = React.useState({});
  
  
    React.useEffect(()=>{
  
    },[])
  
  
    const onInternalChange = e => {
      setStateValue(e.value);
     
    if (e.value)
      setBorderStyle({ borderColor: "var(--primary-color)" , borderWidth:"2px" })
    else
      setBorderStyle({})
  
      if (onChange)
        onChange(e);
    }
    
    return (
      <div className={"w-full "+st.container}>
       
       <Dropdown style={borderStyle}  value={stateValue} onChange={(e) => onInternalChange(e)} options={options} optionLabel={optionLabel}
                placeholder={placeholder} className={"w-full "} />

      
      </div>
    );
  }

const styles = createUseStyles({
  container: {}
});

export default MzDropdown;